import { useEffect } from "react";
import Service from "../Service/http";
import { ClipLoader } from "react-spinners";
import { FiRefreshCcw } from "react-icons/fi";
import { useState } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./UserAllSubmission.css";
import { useNavigate, useParams } from "react-router-dom";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

function UserProblemAllSubmission(props) {
  const service = new Service();
  const { pid } = useParams();

  const handleChange = (e, v) => {
    setPageNo(v);
    setGetApi(getApi + 1);
  };

  const getDelay = (time) => {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  let [valid, setValid] = useState(true);

  let [data, setData] = useState([]); /*Table data*/
  let [pageData, setPageData] = useState({}); /*Meta Data about pages*/
  let [color, Setcolor] = useState('');
  let [background, SetBackground] = useState("#81C784");
  let [textColor, SetTextcolor] = useState("");

  /*Tells when the api need to be called*/
  let [getApi, setGetApi] = useState(0);

  /*Value of the filter applied*/
  let [verdictFilterValue, setverdictFilterValue] = useState("All");
  let [languageFilterValue, setlanguageFilterValue] = useState("All");

  /*List for Filter Dropdown*/
  let [verdicts, setVerdict] = useState(['All', "ACCEPTED", "WRONG ANSWER", "TIME LIMIT EXCEEDED", "RUNTIME ERROR", "PENDING", "OTHER", "COMPILATION ERROR"]);
  let [languages, setLanguage] = useState(['All', "CPP", "C#", "JAVA", "JAVASCRIPT", "PYTHON"]);
  /*Pagination Data*/
  let [pageNo, setPageNo] = useState(1);
  let [perPage, setPerPage] = useState(5);

  const [any_submission_polling, setAny_submission_polling] = useState(false);

  const updateAllSubmission = async () =>{
    try{
    let st = false;
    const json = await service.get("api/userProblemSubmissions/" + pid + '?verdict=' + verdictFilterValue + '&lang=' + languageFilterValue + '&page=' + pageNo + "&perPage=" + perPage);
    let result = []
    let ind = ((json['result']['page'] - 1) * (json['result']['limit']) + 1)
    for await (var ele of json['result']['docs']) {
      let temp = {};
      temp['no'] = ind;
      temp['verdict'] = ele['verdict_string'];
      temp['lang'] = ele['language'];
      temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
      temp['verdictURL'] = '/submission/' + ele['_id'];
      temp['polling'] = ele['is_server_polling'];
      temp['submission_id'] = ele['_id'];
      if (ele['is_server_polling']){
        setAny_submission_polling(true);
        st = true;
      }
      result.push(temp);
      ind++;
    }
    setData(result);
    if (result.length === 0) {
      setValid(false);
    }
    setPageData({ 'total': json['result']['total'], 'limit': json['result']['limit'], 'page': json['result']['page'], 'pages': json['result']['pages'] });
    if (any_submission_polling || st){
      await getDelay(30000);
      updateAllSubmission();
    }
    else if(st == false){
      await getDelay(30000);
      setAny_submission_polling(false);
    }
  }
  catch (error){
    console.log(error);
  }
  }

  const reEvalSubmission = async (id,verdict) =>{
    if (verdict == "PENDING"){
      service.get("api/re-evaluate/submission/old/"+id);
    }
    else{
      service.get("api/re-evaluate/submission/new/"+id);
    }
    await getDelay(10000);
    updateAllSubmission();
  }

  useEffect(() => {
    service
      .get("api/userProblemSubmissions/" + pid + '?verdict=' + verdictFilterValue + '&lang=' + languageFilterValue + '&page=' + pageNo + "&perPage=" + perPage)
      .then((json) => {
        let st = false;
        let result = []
        let ind = ((json['result']['page'] - 1) * (json['result']['limit']) + 1)
        for (var ele of json['result']['docs']) {
          let temp = {};
          temp['no'] = ind;
          temp['verdict'] = ele['verdict_string'];
          temp['lang'] = ele['language'];
          temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
          temp['verdictURL'] = '/submission/' + ele['_id'];
          temp['polling'] = ele['is_server_polling'];
          temp['submission_id'] = ele['_id'];
          if (ele['is_server_polling']){
            setAny_submission_polling(true);
            st = true;
          }
          result.push(temp);
          ind++;
        }
        setData(result);
        if (result.length === 0) {
          setValid(false);
        }
        setPageData({ 'total': json['result']['total'], 'limit': json['result']['limit'], 'page': json['result']['page'], 'pages': json['result']['pages'] });
        if (any_submission_polling || st){
          updateAllSubmission();
        }
        else{
          if (st == false){
            getDelay(30000).then(() => {
              setAny_submission_polling(false);
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [getApi]);

  const navigate = useNavigate();

  const moveToProblemCode = () => {
    navigate("/code/"+pid);
  }


  return (
    <div>
      <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                onClick={moveToProblemCode}
                aria-selected="false"
                role="tab"
                style={{fontWeight: "bolder", cursor:"pointer"}}
              >
                Problem Statement
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                data-bs-toggle="tab"
                href="#problem_submissions_cur_user"
                aria-selected="true"
                role="tab"
                style={{fontWeight: "bolder"}}
              >
                Submissions
              </a>
            </li>
          </ul>
      <div id="problem_submissions_cur_user"><ReactTableFixedColumns
                sortable={false}
                data={data}
                pageSize={data?.length || perPage}
                showPagination={false}
                style={{fontWeight: "bold"}}
                columns={[
                  {
                    Header: () => <div className="UserProblemSubmissionsHeader">No </div>,
                    accessor: "no",
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: (rowInfo?.original?.my) ? color: textColor,
                          background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                        },
                      };
                    },
                    minWidth: 50,
                  },
                  {
                    Header: () => (<div className="UserProblemSubmissionsHeader">Verdict<br /><select id="verdict" onChange={(e) => { setverdictFilterValue(e.target.value); setGetApi(getApi + 1) }} >{verdicts.map(verdict => { return (<option value={verdict}> {verdict} </option>) })}</select></div>),
                    accessor: "verdict",
                    Cell: e => {
                    return(
                      <div>
                      {e.original.polling?
                        <ClipLoader style={{
                          marginTop : "1rem !important"
                        }} color="#4169E1" size="16" />:
                      e.original.polling == false && (e.original.verdict == 'PENDING')?
                      <FiRefreshCcw onClick={() =>{
                        let dummy = [...data];
                        dummy[e.original.no-1]['verdict'] = "PENDING";
                        dummy[e.original.no-1]['polling'] = true;
                        setData(dummy);
                        reEvalSubmission(e.original.submission_id, e.original.verdict);
                       }} title="Refresh" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} 
                         color="#FFC000" size="18" />: 
                         e.original.polling == false && e.original.verdict == 'SERVER ERROR'?
                         <FiRefreshCcw onClick={() =>{
                          let dummy = [...data];
                          dummy[e.original.no-1]['verdict'] = "PENDING";
                          dummy[e.original.no-1]['polling'] = true;
                          setData(dummy);
                          reEvalSubmission(e.original.submission_id, e.original.verdict);
                          e.original.verdict = "PENDING";
                         }} title="Re-evaluate" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} 
                         color="#FFC000" size="18" />: null}
                    <a href={e.original.verdictURL} style={{textDecoration: 'none !important', color:  e.original.verdict === 'ACCEPTED' ? "#76B947" : e.original.verdict =='PENDING' || e.original.verdict =='SERVER ERROR' ? textColor :  "#E43D40"}} target="_blank"> {e.original.verdict} </a>
                    </div>
                  );
                },
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: (rowInfo?.original?.my) ? color : textColor,
                          background: rowInfo?.original?.my? "#E8E8E8" : "#E8E8E8",
                        },
                      };
                    },
                    minWidth: 500,
                  },
                  {
                    Header: () => (<div className="UserProblemSubmissionsHeader">Language<br /><select id="language" onChange={(e) => { setlanguageFilterValue(e.target.value); setGetApi(getApi + 1); }}>{languages.map(language => { return (<option value={language}> {language} </option>) })}</select></div>),
                    accessor: "lang",
                    Cell: e => <a href={e.original.verdictURL} color={textColor} target="_blank"> {e.original.lang} </a>,
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: (rowInfo?.original?.my) ? color : textColor,
                          background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                        },
                      };
                    },
                    minWidth: 450,
                  },
                  {
                    Header: () => <div className="UserProblemSubmissionsHeader">Time</div>,
                    accessor: "timestamp",
                    sortable: true,
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: (rowInfo?.original?.my) ? color : textColor,
                          background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                        },
                      };
                    },
                    minWidth: 250,
                  },
                ]}
                className=" -highlight text-dark h5"
              />
                <Stack className="float-end" spacing={2}>
                  <Pagination
                    count={pageData['pages']}
                    color="primary"
                    defaultPage={1}
                    page={pageNo}
                    onChange={handleChange}
                  />
                </Stack>
                <div><select name="pagesize" id="pagesize" onChange={(e) => { setPerPage(e.target.value); setGetApi(getApi + 1); }}><option value={5}>5</option><option value={10}>10</option><option value={20}>20</option><option value={50}>50</option><option value={100}>100</option></select></div></div>
                </div>
  );

}

export default UserProblemAllSubmission;